import { incApi } from 'api/inc-api';

/**
 * For endpoints that are directly on the admin-api. They do not forward to other internal services
 */
const endpoints = incApi.injectEndpoints({
  overrideExisting: true,
  endpoints: build => ({
    chmlnSignature: build.query<{ uidHash: string }, { uid: string }>({
      query: () => ({
        url: `chmlnsignature`,
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useLazyChmlnSignatureQuery } = endpoints;
